export default __webpack_public_path__ + "static/media/oddsFeed3.49fa46cf.png";